export const DISPOSITION_CONTROL_KEYS = {
  CONTINUE_DIALING_LIST: "dialing-list",
} as const;

export const MIN_CONVERSATION_TIME_SECONDS = 30;
